import React, { useState, useEffect } from "react";
import Navbar from "../../components/template/Navbar";
import Template from "../../components/template/Template";
import Cookies from "js-cookie";
import {
  AxiosCustomGet,
  AxiosCustomPut,
} from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import { useHistory } from "react-router-dom";
import AppRoutePath from "../../router/AppRoutePath";
import { Button } from "antd";
import { MdSave } from "react-icons/md";

function UpdateRole(props) {
  const [groupedActions, setGroupedActions] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [name, setName] = useState();
  const [description, setDescription] = useState();
  const [groupedPermissions, setGroupedPermissions] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [roleValue, setRoleValue] = useState([]);
  const [loginType, setLoginType] = useState({});
  const [actions, setActions] = useState({});

  const history = useHistory();
  const id = props.match.params.id;

  // const handleCheckbox = (e, element) => {
  //   let newGroupedPermission = groupedPermissions;
  //   let { checked, action, action_key } = e.target;

  //   let data = {
  //     action,
  //     action_key,
  //     is_allowed: checked,
  //   };

  //   // for (let i = 0; i < roleValue.length; i++) {
  //   //   if (i == index) {
  //   //     for (let j = 0; j < roleValue[i].length; j++) {
  //   //       if (j == index2) {
  //   //         roleValue[i][j] = data;
  //   //         setRoleValue([...roleValue]);
  //   //       }
  //   //     }
  //   //   }
  //   // }

  //   let arrIndex = element.permissions.findIndex(
  //     (obj) => obj.action_key === e.target.getAttribute("action_key")
  //   );
  //   element.permissions[arrIndex] = {
  //     action: e.target.getAttribute("action"),
  //     action_key: e.target.getAttribute("action_key"),
  //     is_allowed: checked,
  //   };

  //   let dataPermissions = {
  //     name: element.name,
  //     key: element.key,
  //     permissions: [...element.permissions],
  //   };

  //   // console.log("data", checked);
  //   console.log("data", dataPermissions);

  //   let objIndex = newGroupedPermission.findIndex(
  //     (obj) => obj.key === dataPermissions.key
  //   );

  //   console.log("objIndex", objIndex);
  //   newGroupedPermission[objIndex] = dataPermissions;
  //   setGroupedPermissions([...newGroupedPermission]);

  //   // for (let i = 0; i < groupedPermissions.length; i++) {
  //   //   if (i == index) {
  //   //     for (let j = 0; j < groupedPermissions[i].length; j++) {
  //   //       if (j == index2) {
  //   //         groupedPermissions[i][j] = data;
  //   //         setGroupedPermissions([...groupedPermissions]);
  //   //       }
  //   //     }
  //   //   }
  //   // }
  // };

  const handleCheckbox = (e) => {
    let { name, checked } = e.target;
    setPermissions((prev) => ({
      ...prev,
      [name]: checked,
    }));
    if (
      name == "view_pick_up_gadai" ||
      name == "view_sheduled_pick_up_gadai" ||
      name == "view_delivery_gadai" ||
      name == "view_scheduled_delivery_gadai" ||
      name == "view_history_delivery_gadai" ||
      name == "view_area"
    ) {
      setPermissions((prev) => ({
        ...prev,
        view_employee: true,
      }));
    }
  };

  useEffect(() => {
    setName(props?.location?.state.name);
    setDescription(props?.location?.state.description);
    getGroupedActions();
    getGroupedPermission();
    getRolePermission();
    getLoginPermissions();
    getActions();
  }, []);

  const getActions = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}permissions/actions`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setActions(response.data.data);
      }
    );
  };

  const getGroupedActions = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}permissions/groupedActions`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setGroupedActions(response.data.data);
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getGroupedPermission = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}role/${id}/groupedPermissions`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        let role = [];
        setGroupedPermissions(response.data.data);
        response.data.data.map((item) => {
          role.push(item.permissions);
          // item.permissions.map((element) => {
          //   role.push(element);
          // });
        });
        setRoleValue(role);
        console.log("role", role);
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getRolePermission = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}role/${id}/permissions`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setPermissions(response.data.data);
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getLoginPermissions = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}role/${id}/login-permissions`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoginType(response.data.data);
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      for (let i = 0; i < actions.length; i++) {
        let actionTemp = actions[i];
        setPermissions((prev) => ({
          ...prev,
          [actionTemp]: true,
        }));
      }
    } else {
      setPermissions({});
    }
  };

  const UpdateRolePermission = () => {
    let data = {};
    // let permissions = {};
    // for (let i = 0; i < roleValue.length; i++) {
    //   for (let j = 0; j < roleValue[i].length; j++) {
    //     permissions[roleValue[i][j].action_key] = roleValue[i][j].is_allowed;
    //   }
    // }
    data = {
      name,
      permissions: !loginType.login_web ? {} : permissions,
      description: " ",
      login_permissions: loginType,
    };
    console.log(permissions);
    let url = `${process.env.REACT_APP_BASE_API_URL}role/${id}`;
    if (name === undefined || name === "") {
      SwalToast.fire({
        icon: "error",
        title: "Nama Role Belum diisi",
      });
    } else {
      AxiosCustomPut(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        (response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          history.push(AppRoutePath.ROLE);
        },
        (error) => {
          console.log(error);
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: error.response.data,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        }
      );
    }
  };

  const handleChangeLoginType = (e) => {
    const { name, checked } = e.target;
    setLoginType((prev) => ({
      ...prev,
      [name]: checked,
    }));
    console.log(loginType);
  };
  return (
    <div>
      <div style={{ padding: 24 }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: "#303030" }}>
          Ubah Role
        </div>
        <div
          style={{
            marginTop: 30,
            padding: 20,
            boxShadow: "0px 4px 12px rgba(54, 53, 53, 0.12)",
            borderRadius: 10,
          }}
        >
          <div style={{ fontWeight: 600 }}>Ubah Pengaturan Role</div>
          <div style={{ marginTop: 24 }}>
            <div style={{ color: "#A6A6A6" }}>Nama Role</div>
            <input
              type="text"
              className="form-control border-DCDCDC mt-1"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div style={{ marginTop: 24 }}>
            <div style={{ color: "#A6A6A6", marginBottom: 10 }}>Login Type</div>
            <div style={{ margin: "20px 0 0 0" }}>
              <div style={{ display: "flex", width: "50%" }}>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    name="login_front_office"
                    style={{ accentColor: "#fa6629", width: 15, height: 15 }}
                    type="checkbox"
                    onChange={handleChangeLoginType}
                    checked={loginType.login_front_office}
                  />
                  <p style={{ margin: "0px 0px 0px 10px" }}>Front Office</p>
                </div>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    name="login_valuator"
                    style={{ accentColor: "#fa6629", width: 15, height: 15 }}
                    type="checkbox"
                    onChange={handleChangeLoginType}
                    checked={loginType.login_valuator}
                  />
                  <p style={{ margin: "0px 0px 0px 10px" }}>Valuator</p>
                </div>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    name="login_web"
                    style={{ accentColor: "#fa6629", width: 15, height: 15 }}
                    type="checkbox"
                    onChange={handleChangeLoginType}
                    checked={loginType.login_web}
                  />
                  <p style={{ margin: "0px 0px 0px 10px" }}>Web</p>
                </div>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 24 }}>
            <div style={{ color: "#A6A6A6", marginBottom: 10 }}>Role Akses</div>
            <input
              style={styles.checkbox}
              type="checkbox"
              onChange={(e) => handleCheckAll(e)}
            />{" "}
            Pilih Semua
          </div>
          <div style={{ margin: "20px 0 0 -10px" }}>
            <div style={{ display: "flex", width: "90%" }}>
              <div style={{ flex: 1.8 }} />
              <div style={{ flex: 0.5 }}>Lihat</div>
              <div style={{ flex: 0.5 }}>Tambah</div>
              <div style={{ flex: 0.5 }}>Ubah</div>
              <div style={{ flex: 0.5 }}>Hapus</div>
              <div style={{ flex: 0.5 }}>Print</div>
            </div>
          </div>

          <div style={{ margin: "20px 0 0 -10px" }}>
            <div style={{ width: "90%", display: "flex" }}>
              <br />
              <div style={{ flex: 1.8 }}>
                {groupedPermissions?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        padding: "10px",
                        backgroundColor: index % 2 === 1 && "#F5F5F5",
                      }}
                    >
                      <div style={{ flex: 1 }}>{item.name}</div>
                    </div>
                  );
                })}
              </div>

              <div style={{ flex: 2.5 }}>
                {groupedPermissions.map((element, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        padding: "10px 0",
                        backgroundColor: index % 2 === 1 && "#F5F5F5",
                      }}
                    >
                      {element.permissions.some((v) => v.action === "view") ? (
                        element.permissions.map((el, index2) => {
                          return (
                            <>
                              {el.action === "view" ? (
                                <div key={index2} style={{ flex: 1 }}>
                                  <input
                                    disabled={!loginType.login_web}
                                    checked={
                                      !loginType.login_web
                                        ? false
                                        : permissions[el.action_key]
                                    }
                                    action_key={el.action_key}
                                    name={el.action_key}
                                    action={el.action}
                                    onChange={(e) => handleCheckbox(e)}
                                    style={{
                                      accentColor: "#fa6629",
                                    }}
                                    type="checkbox"
                                  />
                                </div>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <div style={{ flex: 1 }} />
                      )}

                      {element.permissions.some(
                        (v) => v.action === "create"
                      ) ? (
                        element.permissions.map((el, index2) => {
                          return (
                            <>
                              {el.action === "create" ? (
                                <div key={index2} style={{ flex: 1 }}>
                                  <input
                                    disabled={!loginType.login_web}
                                    checked={
                                      !loginType.login_web
                                        ? false
                                        : permissions[el.action_key]
                                    }
                                    action_key={el.action_key}
                                    name={el.action_key}
                                    action={el.action}
                                    onChange={(e) => handleCheckbox(e)}
                                    style={{
                                      accentColor: "#fa6629",
                                    }}
                                    type="checkbox"
                                  />
                                </div>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <div style={{ flex: 1 }} />
                      )}

                      {element.permissions.some(
                        (v) => v.action === "update"
                      ) ? (
                        element.permissions.map((el, index2) => {
                          return (
                            <>
                              {el.action === "update" ? (
                                <div key={index2} style={{ flex: 1 }}>
                                  <input
                                    disabled={!loginType.login_web}
                                    checked={
                                      !loginType.login_web
                                        ? false
                                        : permissions[el.action_key]
                                    }
                                    action_key={el.action_key}
                                    name={el.action_key}
                                    action={el.action}
                                    onChange={(e) => handleCheckbox(e)}
                                    style={{
                                      accentColor: "#fa6629",
                                    }}
                                    type="checkbox"
                                  />
                                </div>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <div style={{ flex: 1 }} />
                      )}

                      {element.permissions.some(
                        (v) => v.action === "delete"
                      ) ? (
                        element.permissions.map((el, index2) => {
                          return (
                            <>
                              {el.action === "delete" ? (
                                <div key={index2} style={{ flex: 1 }}>
                                  <input
                                    disabled={!loginType.login_web}
                                    checked={
                                      !loginType.login_web
                                        ? false
                                        : permissions[el.action_key]
                                    }
                                    action_key={el.action_key}
                                    name={el.action_key}
                                    action={el.action}
                                    onChange={(e) => handleCheckbox(e)}
                                    style={{
                                      accentColor: "#fa6629",
                                    }}
                                    type="checkbox"
                                  />
                                </div>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <div style={{ flex: 1 }} />
                      )}

                      {element.permissions.some((v) => v.action === "print") ? (
                        element.permissions.map((el, index2) => {
                          return (
                            <>
                              {el.action === "print" ? (
                                <div key={index2} style={{ flex: 1 }}>
                                  <input
                                    disabled={!loginType.login_web}
                                    checked={
                                      !loginType.login_web
                                        ? false
                                        : permissions[el.action_key]
                                    }
                                    action_key={el.action_key}
                                    name={el.action_key}
                                    action={el.action}
                                    onChange={(e) => handleCheckbox(e)}
                                    style={{
                                      accentColor: "#fa6629",
                                    }}
                                    type="checkbox"
                                  />
                                </div>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <div style={{ flex: 1 }} />
                      )}
                    </div>
                  );
                })}

                {/* <div style={{ flex: 2.5 }}>
                  {roleValue.map((element, index) => {
                    return (
                      <div style={{ display: "flex", margin: "10px 0" }}>
                        {element.map((e, index2) => {
                          return (
                            <div
                              style={{
                                flex: roleValue[index].length == 2 ? 1 : 0.5,
                              }}
                            >
                              <input
                                // value={element.action_key}
                                checked={e.is_allowed}
                                name={e.action_key}
                                id={e.action}
                                onChange={(e) =>
                                  handleCheckbox(e, index, index2)
                                }
                                style={{
                                  accentColor: "#fa6629",
                                }}
                                type="checkbox"
                              />
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end", margin: 20 }}
        >
          <Button
            onClick={() => history.goBack()}
            // onClick={() => {
            //   console.log("permissionRole ", permissionRole);
            //   console.log("groupedPermissions ", groupedPermissions);
            // }}
            style={{
              margin: 5,
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>
          <Button
            onClick={() => UpdateRolePermission()}
            type="submit"
            disabled={submitting}
            style={{
              margin: 5,
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            <MdSave style={{ fontSize: 20, marginRight: 5 }} />
            Simpan
          </Button>
        </div>
      </div>
    </div>
  );
}

export default UpdateRole;

const styles = {
  checkbox: {
    accentColor: "#fa6629",
    width: 15,
    height: 15,
    margin: "9px 0",
  },
};
